<template>
  <section id="solution-bridge" class="py-16 md:py-24 bg-base-200">
    <div class="max-w-screen-xl mx-auto px-4">
      <!-- Section Header -->
      <div class="text-center mb-16">
        <h2 class="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-base-content">
          {{ $t("solutionBridge.heading") }}
        </h2>
        <div class="divider divider-primary w-32 mx-auto mt-6"></div>
        <p class="text-lg text-base-content/80 max-w-2xl mx-auto mt-4">
          {{ $t("solutionBridge.empathy") }}
        </p>
      </div>

      <!-- Transformation Promise -->
      <div class="card bg-base-100 shadow-lg mb-8 max-w-4xl mx-auto">
        <div class="card-body">
          <h3 class="text-2xl font-bold text-primary mb-4 text-center">
            {{ $t("solutionBridge.transformationQuestion") }}
          </h3>

          <p class="text-lg text-base-content/80 mb-8 text-center">
            {{ $t("solutionBridge.systemDescription") }}
          </p>

          <!-- Solution Preview Grid -->
          <div class="grid md:grid-cols-2 gap-6">
            <div class="flex items-start gap-3">
              <div class="w-6 h-6 bg-success rounded-full flex items-center justify-center flex-shrink-0">
                <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd" />
                </svg>
              </div>
              <p class="text-base-content">
                {{ $t("solutionBridge.solution1") }}
              </p>
            </div>

            <div class="flex items-start gap-3">
              <div class="w-6 h-6 bg-success rounded-full flex items-center justify-center flex-shrink-0">
                <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd" />
                </svg>
              </div>
              <p class="text-base-content">
                {{ $t("solutionBridge.solution2") }}
              </p>
            </div>

            <div class="flex items-start gap-3">
              <div class="w-6 h-6 bg-success rounded-full flex items-center justify-center flex-shrink-0">
                <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd" />
                </svg>
              </div>
              <p class="text-base-content">
                {{ $t("solutionBridge.solution3") }}
              </p>
            </div>

            <div class="flex items-start gap-3">
              <div class="w-6 h-6 bg-success rounded-full flex items-center justify-center flex-shrink-0">
                <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd" />
                </svg>
              </div>
              <p class="text-base-content">
                {{ $t("solutionBridge.solution4") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- Hope/Relief Statement -->
      <div class="alert alert-success shadow-lg mb-8 max-w-4xl mx-auto">
        <div class="flex-1">
          <p class="text-lg font-medium leading-relaxed">
            {{ $t("solutionBridge.wayForward") }}
          </p>
        </div>
      </div>

      <!-- Transition Call-to-Action -->
      <div class="text-center">
        <div class="card bg-primary text-primary-content shadow-lg max-w-2xl mx-auto">
          <div class="card-body">
            <p class="text-lg font-medium mb-4">
              {{ $t("solutionBridge.missingPiece") }}
            </p>
            <div class="animate-bounce">
              <svg class="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
// No additional logic needed for this component
</script>
